export default {
  metadata: {
    version: '1.0.0',
    id: 'nudge-1.0.0',
    name: 'JDSNudge'
  },
  hierarchy: {
    'root-container': [
      {
        'base-container': [
          'left-slot',
          {
            'center-container': ['heading-jds-text', 'support-jds-text']
          },
          'close-jds_notification_button',
          'right-slot'
        ]
      },
      {
        'buttons-container': [
          'secondary-jds_notification_button',
          'primary-jds_notification_button'
        ]
      }
    ]
  },
  base: {
    'root-container': {
      width: '{n_0}',
      'max-width': '{n_1}',
      'border-radius': '{n_2}',
      'background-color': '{n_3}',
      'flex-direction': '{n_4}',
      gap: '{n_5}',
      'padding-top': '{n_6}',
      'padding-right': '{n_7}',
      'padding-bottom': '{n_8}',
      'padding-left': '{n_9}',
      'enter-animation-name': 'slideVerticallyDown',
      'exit-animation-name': 'slideVerticallyUp',
      'enter-animation-curve': 'entrance_ease',
      'exit-animation-curve': 'exit_ease',
      'enter-animation-duration': 500,
      'exit-animation-duration': 500,
      transition: {
        property: ['translate-x', 'translate-y'],
        duration: '{medium}',
        'timing-function': '{easeJoyfulExit}'
      },
      hidden: true
    },
    'base-container': {
      gap: '{n_10}',
      'flex-direction': '{n_12}',
      'justify-content': '{n_13}',
      'align-items': '{n_14}',
      width: '{n_11}'
    },
    'center-container': {
      'flex-direction': '{n_15}',
      'justify-content': '{n_16}',
      'align-items': '{n_17}',
      gap: '{n_18}',
      flex: 1
    },
    'close-jds_notification_button': {
      hidden: false,
      icon: 'ic_close',
      kind: 'tertiary'
    },
    'buttons-container': {
      show: false,
      gap: '{n_20}',
      'flex-direction': '{n_21}',
      'justify-content': '{n_22}',
      width: '{n_19}'
    },
    'secondary-jds_notification_button': {
      kind: 'tertiary'
    },
    'right-slot': {
      hidden: true
    },
    'heading-jds-text': {
      'font-family': '{text_137}',
      color: '{text_19}',
      'font-size': '{text_136}',
      'line-height': '{text_138}',
      'letter-spacing': '{text_139}',
      'font-weight': '{text_140}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'max-lines': 1,
      maxLines: 1
    },
    'support-jds-text': {
      'font-family': '{text_147}',
      color: '{text_24}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'max-lines': 1,
      maxLines: 1
    }
  },
  variant: {
    open: {
      true: {
        'root-container': {
          hidden: false,
          transition: {
            'timing-function': '{easeJoyfulEntrance}'
          }
        }
      }
    },
    showClose: {
      false: {
        'close-jds_notification_button': {
          hidden: true
        },
        'right-slot': {
          hidden: false
        }
      }
    },
    _platform: {
      tablet: {
        'root-container': {
          'max-width': '{n_23}',
          'enter-animation-name': 'slideHorizontallyToLeft',
          'exit-animation-name': 'slideHorizontallyToRight'
        }
      },
      desktop: {
        'root-container': {
          'max-width': '{n_24}',
          'enter-animation-name': 'slideHorizontallyToLeft',
          'exit-animation-name': 'slideHorizontallyToRight'
        }
      }
    },
    _hasCTA: {
      false: {
        'buttons-container': {
          hidden: true
        }
      }
    },
    _hasDescription: {
      false: {
        'support-jds-text': {
          hidden: true
        },
        'heading-jds-text': {
          'max-lines': 2,
          maxLines: 2
        }
      }
    }
  },
  combination: [
    {
      false: {
        mobile: {
          'root-container': {
            'translate-y': '{size.negativeMax}'
          }
        },
        tablet: {
          'root-container': {
            'translate-x': '{size.max}'
          }
        },
        desktop: {
          'root-container': {
            'translate-x': '{size.max}'
          }
        }
      },
      true: {
        mobile: {
          'root-container': {
            'translate-y': 0
          }
        },
        tablet: {
          'root-container': {
            'translate-x': 0
          }
        },
        desktop: {
          'root-container': {
            'translate-x': 0
          }
        }
      }
    }
  ],
  combination_config: [['open', '_platform']],
  api: {
    config: {
      open: {
        values: [false, true]
      },
      showClose: {
        values: [true, false],
        doc_description: 'This shows close button on Nudge when true.'
      },
      _platform: {
        values: ['mobile', 'tablet', 'desktop']
      },
      _hasCTA: {
        values: [true, false]
      },
      _hasDescription: {
        values: [true, false]
      }
    },
    data: {
      'root-container': {
        '_nudge.id': {
          type: 'NotificationId',
          name: 'id',
          required: true,
          doc_description: 'It will hold the reference of Nudge'
        }
      },
      'secondary-jds_notification_button': {
        label: {
          type: 'string',
          name: 'secondaryCTA',
          doc_description: 'It displays label of secondary button of Nudge.'
        }
      },
      'primary-jds_notification_button': {
        label: {
          type: 'string',
          name: 'primaryCTA',
          doc_description: 'It displays label of primary button of Nudge.'
        }
      },
      'heading-jds-text': {
        value: {
          type: 'string',
          name: 'title',
          doc_description: 'It displays the title of Nudge.'
        }
      },
      'support-jds-text': {
        value: {
          type: 'string',
          name: 'description',
          doc_description: 'It can be used to add description to the Nudge.'
        }
      }
    },
    events: {
      'root-container': {
        onShow: 'onShow',
        onHover: {
          name: 'onHover',
          platform: 'web'
        },
        onUpdate: {
          name: 'onUpdate',
          platform: 'android'
        },
        onHoverEnd: {
          name: 'onHoverEnd',
          platform: 'web'
        },
        onSwipeUp: 'onClose'
      },
      'close-jds_notification_button': {
        onClick: 'onClose'
      },
      'secondary-jds_notification_button': {
        onClick: 'onSecondaryClick'
      },
      'primary-jds_notification_button': {
        onClick: 'onPrimaryClick'
      }
    },
    children: {
      'left-slot': {
        accepts: ['jds_icon', 'jds_avatar'],
        max: 1,
        name: 'prefix',
        doc_description: "It takes 'icon', 'avatar' as prefix."
      },
      'right-slot': {
        accepts: ['jds_notification_button'],
        max: 1,
        name: 'suffix',
        doc_description: "It takes 'jds_notification_button' as suffix."
      }
    },
    a11y: {
      'root-container': {
        properties: {
          role: {
            value: 'alertdialog'
          }
        }
      },
      'close-jds_notification_button': {
        properties: {
          ariaLabel: {
            name: 'closeButtonAriaLabel',
            value: 'Close Nudge'
          }
        }
      },
      'secondary-jds_notification_button': {
        properties: {
          ariaLabel: 'secondaryCtaAriaLabel',
          ariaDescribedby: {
            name: 'secondaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'primary-jds_notification_button': {
        properties: {
          ariaLabel: 'primaryCtaAriaLabel',
          ariaDescribedby: {
            name: 'primaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
